import { render, staticRenderFns } from "./ChatDetails.vue?vue&type=template&id=6937a67e&"
import script from "./ChatDetails.vue?vue&type=script&lang=ts&"
export * from "./ChatDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports